/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserSettings } from './UserSettings';
import {
    UserSettingsFromJSON,
    UserSettingsFromJSONTyped,
    UserSettingsToJSON,
    UserSettingsToJSONTyped,
} from './UserSettings';
import type { CnbMarketingData } from './CnbMarketingData';
import {
    CnbMarketingDataFromJSON,
    CnbMarketingDataFromJSONTyped,
    CnbMarketingDataToJSON,
    CnbMarketingDataToJSONTyped,
} from './CnbMarketingData';
import type { StripeDetails } from './StripeDetails';
import {
    StripeDetailsFromJSON,
    StripeDetailsFromJSONTyped,
    StripeDetailsToJSON,
    StripeDetailsToJSONTyped,
} from './StripeDetails';

/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * Unique identifier of the user
     * @type {string}
     * @memberof User
     */
    id: string;
    /**
     * Whether the user account is active
     * @type {boolean}
     * @memberof User
     */
    active: boolean;
    /**
     * Display name of the user
     * @type {string}
     * @memberof User
     */
    name?: string;
    /**
     * Email address of the user
     * @type {string}
     * @memberof User
     */
    email: string;
    /**
     * Company name of the user (deprecated, use UserStripeApi)
     * @type {string}
     * @memberof User
     * @deprecated
     */
    companyName: string;
    /**
     * Phone number of the user (deprecated, use UserStripeApi)
     * @type {string}
     * @memberof User
     * @deprecated
     */
    phone: string;
    /**
     * Stripe billing details associated with this user
     * @type {StripeDetails}
     * @memberof User
     */
    stripeDetails?: StripeDetails;
    /**
     * List of roles assigned to this user
     * @type {Array<string>}
     * @memberof User
     */
    roles: Array<string>;
    /**
     * Marketing and signup metadata for this user
     * @type {CnbMarketingData}
     * @memberof User
     */
    marketingData?: CnbMarketingData;
    /**
     * Tax IDs associated with the user (deprecated, use UserStripeApi)
     * @type {Array<string>}
     * @memberof User
     */
    taxIds: Array<string>;
    /**
     * Billing address of the user (deprecated, use UserStripeApi)
     * @type {string}
     * @memberof User
     * @deprecated
     */
    address: string;
    /**
     * User-specific settings and preferences
     * @type {UserSettings}
     * @memberof User
     */
    settings?: UserSettings;
}

/**
 * Check if a given object implements the User interface.
 */
export function instanceOfUser(value: object): value is User {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('roles' in value) || value['roles'] === undefined) return false;
    if (!('taxIds' in value) || value['taxIds'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    return true;
}

export function UserFromJSON(json: any): User {
    return UserFromJSONTyped(json, false);
}

export function UserFromJSONTyped(json: any, ignoreDiscriminator: boolean): User {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'active': json['active'],
        'name': json['name'] == null ? undefined : json['name'],
        'email': json['email'],
        'companyName': json['companyName'],
        'phone': json['phone'],
        'stripeDetails': json['stripeDetails'] == null ? undefined : StripeDetailsFromJSON(json['stripeDetails']),
        'roles': json['roles'],
        'marketingData': json['marketingData'] == null ? undefined : CnbMarketingDataFromJSON(json['marketingData']),
        'taxIds': json['taxIds'],
        'address': json['address'],
        'settings': json['settings'] == null ? undefined : UserSettingsFromJSON(json['settings']),
    };
}

export function UserToJSON(json: any): User {
    return UserToJSONTyped(json, false);
}

export function UserToJSONTyped(value?: User | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'active': value['active'],
        'name': value['name'],
        'email': value['email'],
        'companyName': value['companyName'],
        'phone': value['phone'],
        'stripeDetails': StripeDetailsToJSON(value['stripeDetails']),
        'roles': value['roles'],
        'marketingData': CnbMarketingDataToJSON(value['marketingData']),
        'taxIds': value['taxIds'],
        'address': value['address'],
        'settings': UserSettingsToJSON(value['settings']),
    };
}

